const sideNav = function(navItem) {
    const menuItems  = document.querySelectorAll(navItem);

    menuItems.forEach(toggleElem => {
        if($('.sidenav').length){
            const toggleTrigger = toggleElem.querySelector('.sidenav__trigger');
            toggleTrigger.setAttribute('aria-label', 'Toggle submenu for ' + toggleElem.firstElementChild.textContent);
            toggleTrigger.setAttribute('aria-expanded', 'false');
            document.addEventListener('click', e => {
                if(!toggleTrigger.contains(e.target)) 
                    return;
                e.preventDefault();
                openElements(toggleElem);
                let expandedAttr = toggleTrigger.getAttribute("aria-expanded") == 'false' ? 'true' : 'false';
                toggleTrigger.setAttribute('aria-expanded', expandedAttr);
                console.log(e.target);
            });
        }
    });

    function openElements(element) {
        if($('.sidenav').length){
            const elementList = element.querySelector('.sidenav__children');
            element.classList.toggle('is-active');
        }
    }
}

const mobSideNav = function(navObj, breakpoint) {
    if(window.innerWidth < breakpoint) {
        if($('.sidenav').length){
            const sideNav = document.querySelector(navObj);
            const navToggleEl = sideNav.querySelector('.sidenav__title');
            const navToggleList = sideNav.querySelector('.sidenav__nav');
            navToggleEl.innerHTML += '<span role="button" class="sidenav__trigger"><img src="/src/assets/img/nav-arrow-down-white.svg" alt="" /></span>';

            navToggleEl.addEventListener('click', e => {
                e.preventDefault();
                navToggleEl.classList.toggle('is-active')
                navToggleList.classList.toggle('is-visible');
            });
        }
    }
    organizeSideNavViewMobile();
}

const organizeSideNavViewMobile = function() {

    // Check if there sidenav organization process is already done
    if ( document.getElementById('mobile-dynamic-widgets-container') ) return false;
    
    // Look for the sidebar which contains main nav element
    let sidenav = [...document.getElementsByClassName('grid__width-md--4')].find( element => {
        return [...element.children].find( elem => {
            if (elem.tagName === 'NAV' && elem.classList.contains('sidenav')) return elem;
        });
    });

    if ( !sidenav ) return false;
    
    // Remove main nav to have just Widget elements
    const widgets = [...sidenav.children].filter( elem => elem.tagName !== 'NAV')

    // Create HTML container for widgets to be shown just for mobile
    let widgetsContainer = document.createElement('div');
    widgetsContainer.id = 'mobile-dynamic-widgets-container';
    widgetsContainer.className = 'page-mobile-content';

    // Make a copy of the widget containers to add them underneath the main page content
    widgets.forEach(elem => {
        widgetsContainer.appendChild(elem.cloneNode(true));
        elem.classList.add('page-desktop-content');
    });

    const mainContent = document.getElementsByClassName('grid__width-md--8')[0];
    mainContent.appendChild(widgetsContainer);
}

module.exports = {
    initSideNav : sideNav,
    initMobSideNav : mobSideNav
}